import {ModalController} from '../common/modal.controller.js';

class DashboardController {
    constructor(Pacijent, $state, $uibModal) {
        this.$uibModal = $uibModal;
        this.ModelFactory = Pacijent;
        this.$state = $state;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
        };

        this.refreshState();
    }

    refreshState() {
        this.getItems();
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        this.ModelFactory.findAll(params, {bypassCache: true}).then((response) => {
            this.items = response;
            if (angular.isDefined(response.meta)) {
                this.pager.totalItems = response.meta.count;
            }
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.refreshState();
    }

    pageChanged() {
        this.refreshState();
    }

    insert() {
        const model = {};
        const modal = this.$uibModal.open({
            template: '<pacijent-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pacijent-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.$state.go('pacijent.detail', {id: model.id});
        });
    }

    pacijent(item) {
        this.$state.go('pacijent.detail', {id:item.id});
    }

}

DashboardController.$inject = ['Pacijent', '$state', '$uibModal'];

export {DashboardController};



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.controller.js